import { useEffect } from "react"

export const Success = ({ restartGame }) => {

	// remove this
	useEffect(() => {
		console.log('render success')
	}, [])

	return (
		<div>
			<h2>Success</h2>
			<button onClick={() => restartGame(false)}>restart</button>
		</div>
	)
}
